import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getSchemesDiscounts, updateSchemesDiscount, importMobileScheme, downloadMobileSchemeSample } from '@/api/schemes-discounts';
import { getSchemeById } from '@/api/schemes';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import { getDealersRoles } from '@/api/dealers-roles';
import { getAgents } from '@/api/agents';
import { getStates } from '@/api/locations/states';
import { getRanges } from '@/api/ranges';
import { AdminModule } from '@/store/modules/admin';
import { getCategories } from '@/api/categories';
import { searchProducts } from '@/api/products';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.isAgent = false;
    this.schemeId = 0;
    this.isMobileScheme = false;
    this.importDialogVisible = false;
    this.importFile = null;
    this.importing = false;
    this.subCategoryIdRowsCount = {};
    this.productIdRowsCount = {};
    this.roleList = [];
    this.rangeList = [];
    this.stateList = [];
    this.agentList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.productList = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      schemeId: this.schemeId,
      dealersRoleId: undefined,
      rangeId: undefined,
      agentId: undefined,
      stateId: undefined,
      categoryId: undefined,
      subCategoryId: undefined,
      productId: undefined,
      sort: ['dealersRole.id,ASC', 'agent.id,ASC', 'state.id,ASC', 'schemesCategory.id,ASC', 'range.id,ASC', 'category.id,ASC', 'subCategory.id,ASC', 'productId,ASC', 'productsVariation.name,ASC', 'minimumQuantity,ASC'],
      filter: {
        enabled: '$eq',
        schemeId: '$eq',
        dealersRoleId: '$eq',
        agentId: '$eq',
        stateId: '$eq',
        rangeId: '$eq',
        categoryId: '$eq',
        subCategoryId: '$eq',
        productId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.visibleColumns = {
      state: false,
      agent: false,
      action: false
    };
  }
  activated() {
    // check if logged in user is Agent/Admin
    if (AdminModule.userType === 'Agent') {
      this.isAgent = true;
    }
    this.schemeId = parseInt(this.$route.params && this.$route.params.schemeId);
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      schemeId: this.schemeId,
      dealersRoleId: undefined,
      rangeId: undefined,
      agentId: AdminModule.userType === 'Agent' ? AdminModule.agentId : undefined,
      stateId: undefined,
      categoryId: undefined,
      subCategoryId: undefined,
      productId: undefined,
      sort: ['dealersRole.id,ASC', 'agent.id,ASC', 'state.id,ASC', 'schemesCategory.id,ASC', 'range.id,ASC', 'category.id,ASC', 'subCategory.id,ASC', 'productId,ASC', 'productsVariation.name,ASC', 'minimumQuantity,ASC'],
      filter: {
        enabled: '$eq',
        schemeId: '$eq',
        dealersRoleId: '$eq',
        agentId: '$eq',
        stateId: '$eq',
        rangeId: '$eq',
        categoryId: '$eq',
        subCategoryId: '$eq',
        productId: '$eq'
      },
      ...this.$route.query
    };
    // route query values are strings; the filter selects hold numeric ids,
    // so convert them or the selects show the raw id instead of the name
    for (const key of ['dealersRoleId', 'agentId', 'stateId']) {
      if (this.listQuery[key]) this.listQuery[key] = +this.listQuery[key];
    }
    this.fetchScheme();
    this.getList();
    this.fetchDealersRoles();
    this.fetchAgents();
    this.fetchStates();
    this.fetchRanges();
  }
  async fetchScheme() {
    this.isMobileScheme = false;
    try {
      const scheme = await getSchemeById(this.schemeId);
      this.isMobileScheme = !!scheme.forMobile;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleDownloadSample() {
    try {
      const blob = await downloadMobileSchemeSample();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'mobile-scheme-sample.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.$message.error('Error downloading sample');
    }
  }
  async handleImport() {
    if (!this.importFile) return;
    try {
      this.importing = true;
      const formData = new FormData();
      formData.append('file', this.importFile);
      const response = await importMobileScheme(formData);
      this.$message.success(`Imported ${response.totalRecords} records`);
      this.importDialogVisible = false;
      this.getList();
    } catch (error) {
      const errors = error && error.errors || [];
      if (errors.length) {
        const shown = errors.slice(0, 20).map(e => `<div>${e}</div>`);
        if (errors.length > 20) {
          shown.push(`<div>...and ${errors.length - 20} more</div>`);
        }
        this.$alert(shown.join(''), 'Import failed, nothing was saved', {
          dangerouslyUseHTMLString: true,
          type: 'error'
        });
      }
    } finally {
      this.importing = false;
    }
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.schemeId = this.schemeId;
      if (this.listQuery.dealersRoleId || this.listQuery.agentId || this.listQuery.stateId) {
        const data = await getSchemesDiscounts(getQuery(this.listQuery));
        /* find out product id rows count & assign to find product id row */
        this.productIdRowsCount = {};
        this.subCategoryIdRowsCount = {};
        // find out product id rows count & assign to find product id row
        data.data.forEach(item => {
          if (item.productId) {
            if (this.productIdRowsCount[item.productId]) {
              this.productIdRowsCount[item.productId] += 1;
            } else {
              this.productIdRowsCount[item.productId] = 1;
            }
          } else if (item.subCategoryId) {
            if (this.subCategoryIdRowsCount[item.subCategoryId]) {
              this.subCategoryIdRowsCount[item.subCategoryId] += 1;
            } else {
              this.subCategoryIdRowsCount[item.subCategoryId] = 1;
            }
          }
        });
        // add editingQuantity & editingDiscount flag
        data.data.forEach(item => {
          item.editingQuantity = false;
          item.oldMinimumQuantity = item.minimumQuantity;
          item.editingDiscount = false;
          item.oldPercentDiscount = item.percentDiscount;
        });
        this.list = data.data;
        this.total = data.total;
      } else {
        this.list = [];
        this.total = 0;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchAgents() {
    this.agentList = await getAgents(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchStates() {
    this.stateList = await getStates(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$eq'
        }
      }));
      if (this.categoryList.length === 0) {
        this.listQuery.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  async fetchSubCategories() {
    if (this.listQuery.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.listQuery.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$eq',
          rangeId: '$eq'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.listQuery.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  async handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  handleCategoryFilter() {
    this.listQuery.categoryId = undefined;
    this.listQuery.subCategoryId = undefined;
    this.fetchCategories();
    this.getList();
  }
  handleSubCategoryFilter() {
    this.listQuery.subCategoryId = undefined;
    this.fetchSubCategories();
    this.getList();
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  doProductRowSpan(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    return {
      rowspan: 1,
      colspan: 1
    };
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
  getProductDetails(row) {
    const details = [];
    // check for range, category, sub category, product, variation
    if (row.range) {
      details.push(row.range.name);
    }
    if (row.category) {
      details.push(row.category.name);
    }
    if (row.subCategory) {
      details.push(row.subCategory.name);
    }
    if (row.product) {
      details.push(row.product.name);
    }
    if (row.productsVariation) {
      details.push(row.productsVariation.name);
    }
    return details.join(' / ');
  }
  editQuantity(index = -1) {
    if (index === -1) {
      return;
    }
    // check if index is exists in list
    if (index in this.list) {
      this.list[index].editingQuantity = true;
    }
  }
  editDiscount(index = -1) {
    if (index === -1) {
      return;
    }
    // check if index is exists in list
    if (index in this.list) {
      this.list[index].editingDiscount = true;
    }
  }
  async update(index, id, data) {
    try {
      // disable editing flag
      this.list[index].editingQuantity = false;
      this.list[index].editingDiscount = false;
      // update data
      const response = await updateSchemesDiscount(id, data);
      // override only minimumQuantity & percentDiscount
      this.list[index].minimumQuantity = response.minimumQuantity;
      this.list[index].percentDiscount = response.percentDiscount;
      this.$message({
        message: 'updated successfully',
        type: 'success'
      });
    } catch (error) {
      this.$alert('Error updating data', 'Error', {
        confirmButtonText: 'OK',
        type: 'error'
      });
    }
  }
};
default_1 = __decorate([Component({
  name: 'SchemesDiscountList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;